import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { motion } from "framer-motion";

function ToteForm() {

const [loading, setLoading] = useState(false);

const [formData, setFormData] = useState({
fullName: "",
email: "",
phone: "",
city: "",
address: "",
quantity: 1,
message: ""
});

const handleChange = (e) => {
setFormData({
...formData,
[e.target.name]: e.target.value
});
};

const handleSubmit = async (e) => {
e.preventDefault();

setLoading(true);

try {

  if (parseInt(formData.quantity) < 1) {

    Swal.fire({
      icon: "warning",
      title: "Invalid Quantity",
      text: "Please select at least 1 tote bag."
    });

    setLoading(false);
    return;
  }

  const res = await axios.post(
    "https://ekya-backend.onrender.com/api/totebag",
    formData
  );

  Swal.fire({
    icon: "success",
    title: "Pre-Booking Confirmed 🎉",
    text: res.data.message,
    confirmButtonColor: "#2F5D50"
  });

  setFormData({
    fullName: "",
    email: "",
    phone: "",
    city: "",
    address: "",
    quantity: 1,
    message: ""
  });

} catch (error) {

  Swal.fire({
    icon: "error",
    title: "Submission Failed",
    text:
      error.response?.data?.message ||
      "Something went wrong. Please try again."
  });

} finally {

  setLoading(false);

}


};

return (

<div className="min-h-screen bg-[#F8F5F0] py-20 px-6">

  <div className="max-w-6xl mx-auto">

    <motion.div
      initial={{
        opacity: 0,
        y: 40
      }}
      animate={{
        opacity: 1,
        y: 0
      }}
      className="text-center mb-16"
    >

      <h1
        className="
          text-5xl
          md:text-6xl
          font-bold
          text-[#2F5D50]
          mb-5
        "
      >
        Tote Bag Pre-Booking
      </h1>

      <p
        className="
          max-w-3xl
          mx-auto
          text-gray-600
          text-lg
        "
      >
        Reserve your EKYA Tote Bag today and support
        sustainable living while contributing to
        meaningful community initiatives.
      </p>

    </motion.div>

    <div
      className="
        grid
        lg:grid-cols-2
        gap-10
        items-center
      "
    >

     <motion.div
  initial={{
    opacity: 0,
    x: -50
  }}
  animate={{
    opacity: 1,
    x: 0
  }}
  className="
    bg-gradient-to-br
    from-[#2F5D50]
    to-[#4B1D3F]
    rounded-3xl
    p-10
    text-white
    h-full
    flex
    flex-col
    justify-center
    shadow-2xl
  "
>

  <motion.div
    animate={{
      y: [0, -12, 0]
    }}
    transition={{
      duration: 3,
      repeat: Infinity
    }}
    className="text-8xl text-center mb-8"
  >
    👜
  </motion.div>

  <h2
    className="
      text-4xl
      font-bold
      text-center
      mb-6
    "
  >
    EKYA Tote Bags
  </h2>

  <p
    className="
      text-center
      text-gray-200
      leading-relaxed
      text-lg
      mb-8
    "
  >
    Sustainable, stylish and created with purpose.
    Every pre-booking supports EKYA's community
    initiatives and helps us create meaningful
    impact.
  </p>

 <div className="space-y-4">

  <motion.div
    whileHover={{
      scale: 1.04,
      x: 8
    }}
    className="
      bg-white/10
      p-4
      rounded-2xl
      backdrop-blur-sm
      cursor-pointer
      transition-all
      duration-300
      hover:bg-white/20
      hover:shadow-xl
    "
  >
    🌱 Eco-Friendly Material
  </motion.div>

  <motion.div
    whileHover={{
      scale: 1.04,
      x: 8
    }}
    className="
      bg-white/10
      p-4
      rounded-2xl
      backdrop-blur-sm
      cursor-pointer
      transition-all
      duration-300
      hover:bg-white/20
      hover:shadow-xl
    "
  >
    ❤️ Supports Social Initiatives
  </motion.div>

  <motion.div
    whileHover={{
      scale: 1.04,
      x: 8
    }}
    className="
      bg-white/10
      p-4
      rounded-2xl
      backdrop-blur-sm
      cursor-pointer
      transition-all
      duration-300
      hover:bg-white/20
      hover:shadow-xl
    "
  >
    🎁 Perfect For Daily Use
  </motion.div>

  <motion.div
    whileHover={{
      scale: 1.04,
      x: 8
    }}
    className="
      bg-white/10
      p-4
      rounded-2xl
      backdrop-blur-sm
      cursor-pointer
      transition-all
      duration-300
      hover:bg-white/20
      hover:shadow-xl
    "
  >
    ✨ Limited Pre-Booking Available
  </motion.div>

</div>
</motion.div>

      <motion.div
        initial={{
          opacity: 0,
          x: 50
        }}
        animate={{
          opacity: 1,
          x: 0
        }}
        className="
          bg-white
          rounded-3xl
          shadow-xl
          p-10
        "
      >

        <h2
          className="
            text-3xl
            font-bold
            text-[#4B1D3F]
            mb-8
          "
        >
          Reserve Your Tote Bag
        </h2>

        <form
          onSubmit={handleSubmit}
          className="space-y-5"
        >

          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
            required
            className="
              w-full
              border
              p-4
              rounded-2xl
            "
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
            className="
              w-full
              border
              p-4
              rounded-2xl
            "
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
            className="
              w-full
              border
              p-4
              rounded-2xl
            "
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
            className="
              w-full
              border
              p-4
              rounded-2xl
            "
          />

          <textarea
            name="address"
            placeholder="Delivery Address"
            value={formData.address}
            onChange={handleChange}
            required
            rows="3"
            className="
              w-full
              border
              p-4
              rounded-2xl
              resize-none
            "
          />

          <input
            type="number"
            name="quantity"
            min="1"
            value={formData.quantity}
            onChange={handleChange}
            required
            className="
              w-full
              border
              p-4
              rounded-2xl
            "
          />

          <textarea
            name="message"
            placeholder="Message (Optional)"
            value={formData.message}
            onChange={handleChange}
            rows="4"
            className="
              w-full
              border
              p-4
              rounded-2xl
              resize-none
            "
          />

          <button
            type="submit"
            disabled={loading}
            className="
              w-full
              bg-[#2F5D50]
              text-white
              py-4
              rounded-2xl
              font-semibold
              transition-all
              duration-300
              hover:scale-[1.02]
              disabled:opacity-50
            "
          >
            {loading
              ? "Submitting..."
              : "Reserve My Tote Bag"}
          </button>

        </form>

      </motion.div>

    </div>

  </div>

</div>


);
}

export default ToteForm;
